<div class="pv-2 px-2">
  <header class="circle-icon">
    <span class="title">
      Arquivos
      <i class="fas fa-circle-arrow-up"></i>
      <span class="subtitle">Insira os arquivos relacionados a este documento</span>
    </span>
  </header>
</div>
<mat-dialog-content class="mat-typography">
  <div class="form-group">
    <div class="row">
      <div class="col-sm-12">
        <div class="alert alert-info font-13 click flex center" role="alert">
          <label for="file" class="text-center btn btn-cancel">Selecione</label>
          <input id="file" type="file" class="form-control d-none" (change)="fileChangeEvent($event.target.files)" />
          <strong>(PDF, PNG, JPEG, XLS, XLSX, CSV</strong>
          | max.
          <strong>15mb)</strong>
        </div>
      </div>
    </div>
  </div>
  <hr />
  <div *ngIf="!showCropped && croppedImageFile" class="col-sm-12 text-white">
    <div class="image-name-content">
      <div class="files-list">
        <div class="single-file">
          <div class="file-icon px pv-1">
            <img src="./assets/images/icon-file-upload.svg" alt="icone upload de arquivo" />
          </div>
          <div class="info col-12">
            <h4 class="name">{{ croppedImageFile?.name }}</h4>
            <p class="size">{{ formatBytes(croppedImageFile?.size) }}</p>
          </div>
          <div class="delete px pv-1 col-1" (click)="deleteFile(i)">
            <i class="fg fg-vuesaxlineartrash"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="pdfChangedEvent" class="col-sm-12 text-white">
    <div class="row justify-content-between rounded p-2 image-name-content">
      <span>
        <i class="fas fa-file mr-1"></i>
        {{pdfChangedEvent.target.files[0].name}}
      </span>
    </div>
  </div>
  <div class="row" *ngIf="showCropped && !pdfChangedEvent">
    <div class="col-sm-6">
      <div class="text-center card-box p-2">
        <label>Imagem</label>
        <div class="pt-2 pb-3">
          <image-cropper
            [imageChangedEvent]="imageChangedEvent"
            [maintainAspectRatio]="false"
            [aspectRatio]="ratio"
            [cropperMinWidth]="90"
            [cropperMinHeight]="90"
            (imageCropped)="imageCropped($event)"
          ></image-cropper>
        </div>
      </div>
    </div>
    <div class="col-sm-6" *ngIf="croppedImageBase">
      <div class="text-center card-box p-2">
        <label>Pré-visualização</label>
        <div class="pt-2 pb-2">
          <img [src]="croppedImageBase" width="200" height="auto" />
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="pb-3 d-flex float-right">
  <button type="button" mat-dialog-close class="btn btn-cancel mr-2">Cancelar</button>
  <button type="button" class="btn btn-success" *ngIf="showCropped && !pdfChangedEvent" (click)="closeCropped()">
    Ok
  </button>
  <button type="button" class="btn btn-success" *ngIf="!showCropped || pdfChangedEvent" (click)="close()">
    Enviar
  </button>
</mat-dialog-actions>
